module.exports = __webpack_public_path__ + "static/media/ot-courier-default.1bd385b2.svg";